import { useContext } from 'react';
import { GuideContext } from '../contexts/GuideContext';

export const useGuide = () => useContext(GuideContext);
